module.exports = "/images/Right.svg?364cc842637d0274e8d5d617915b00e5";